import React, { useEffect, useCallback, useState} from 'react';
import Modulators from 'components/effects/Modulators.js';
import EffectParameterSlider from "components/effects/EffectParameterSlider.js";
import {connect} from 'react-redux';
import Colors from 'components/Colors.js';
const colors = new Colors();

const MacroInfo = ({macro, macroToShow, setMacroToShow}) => { 
    let selected = macro === macroToShow;
    let sequencerEngine = macro.effect.track.sequencerEngine;
    let parameter = macro.signalParameter;
    console.log("parameter=", parameter);
    return (
        <div className="macro-info">
          <div style={{backgroundColor: colors.getColorForHash(macro.id)}} className="macro-indicator"/>
          <div className="macro-name">
            {macro.name}
          </div>
          <Modulators
            parameter={parameter}
            sequencerEngine={sequencerEngine}
            disconnectFromLFO={(x,y) => macro.disconnectFromLFO(x,y)}
            connectToLFO={(x,y) => macro.connectToLFO(x,y)}
          />
          <div
            onClick={() => setMacroToShow(selected ? undefined : macro)}
            className={selected ? "selected macro-show-btn" : "macro-show-btn"}>
            {selected ? "Collapse" : "Expand"}
          </div>
        </div>
    );
}

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(MacroInfo);
